import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef23f296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login__item user-login__register" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login__sec" }, "账号注册", -1))
const _hoisted_3 = { class: "user-login__register-foot" }

import { ref, defineModel } from 'vue';
import { BaseButton } from 'xrk-components';

import { LoginForm } from './login-base/index';
import type { FormRef } from '../types/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { phoneRegistration } from '../data-source/apis';

import { useSetup } from '../store';

const forgetThePassword = 1;
// 表单实例

export default /*#__PURE__*/_defineComponent({
  __name: 'login-register',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const store = useSetup();

const formData = ref({ agreement: store.loginData.agreement });
const itemList = [FormItemEnum.phone, FormItemEnum.agreement];
const model = _useModel(__props, "modelValue");
const formRef = ref<FormRef>(null);

const onMain = () => {
  store.setLoginData({
    ...store.loginData,
    agreement: formRef.value.data.agreement
  });
  model.value = 'login-main';
};

const onLogin = async () => {
  await formRef.value.validate();
  const { data } = await phoneRegistration({
    [FormItemEnum.phone]: formRef.value.data[FormItemEnum.phone],
    [FormItemEnum.code]: formRef.value.data[FormItemEnum.code],
    forgetThePassword
  });
  // 仅同步信息
  store.setInfo(data);
  model.value = 'login-setpwd';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(LoginForm), {
      ref_key: "formRef",
      ref: formRef,
      formData: formData.value,
      itemList: itemList,
      pageType: _unref(LoginTypeEnum).REGISTER
    }, null, 8, ["formData", "pageType"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(BaseButton), {
        click: onLogin,
        class: "user-login__register-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 立即注册 ")
        ]),
        _: 1
      }),
      _createElementVNode("p", { class: "user-login__register-change" }, [
        _createTextVNode(" 已有账号， "),
        _createElementVNode("span", {
          style: {"color":"#fa8100"},
          onClick: onMain
        }, "登录")
      ])
    ])
  ]))
}
}

})